<template>
  <div class="banner__tab tab">
    <div class="tab__left">
      <h1>{{ $t("HELP_CENTER") }}</h1>
      <p>{{ $t("ABOUT_TEXT") }}</p>
    </div>
    <div class="tab__right">
      <img
        src="@/assets/images/QDLOp3qTiVzuezlhsT44y.svg"
        :alt="$t('ABOUT_TEXT')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ProjectBannerInfoTab"
};
</script>
